import { useTheme } from "next-themes";
import { Moon, Sun, Monitor } from "lucide-react";

/** Segmented theme toggle: light / dark / system */
export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const active = theme || "light";

  const opts = [
    { v: "light", icon: Sun, label: "Light" },
    { v: "dark", icon: Moon, label: "Dark" },
    { v: "system", icon: Monitor, label: "System" },
  ];
  return (
    <div className="inline-flex items-center border border-white/25 rounded-md bg-white/10 p-0.5" data-testid="theme-toggle">
      {opts.map(o => (
        <button
          key={o.v}
          data-testid={`theme-${o.v}`}
          onClick={() => setTheme(o.v)}
          aria-label={o.label}
          suppressHydrationWarning
          className={`px-2 py-1 rounded-[4px] transition ${active === o.v ? "bg-white text-primary" : "text-white/80 hover:text-white hover:bg-white/10"}`}
        >
          <o.icon size={14} />
        </button>
      ))}
    </div>
  );
}
